<template>
  <button :type="buttonType" :class="button({ type, size })">
    <span v-if="loading" class="icon-[line-md--loading-loop] size-6"></span>
    <slot v-else />
  </button>
</template>

<script setup lang="ts">
import { cva, type VariantProps } from 'class-variance-authority'

const button = cva(
  'font-medium disabled:opacity-30 disabled:cursor-not-allowed  focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 min-w-20 flex items-center justify-center',
  {
    variants: {
      type: {
        primary: 'bg-primary hover:bg-primary/90 text-white hover:bg-primary-hover',
        success: 'bg-green-500 hover:bg-green-600 text-white',
        danger: 'bg-red-500 hover:bg-red-600 text-white',
        warning: 'bg-yellow-500 hover:bg-yellow-600 text-black',
        info: 'bg-blue-500 hover:bg-blue-600 text-white',
        secondary: 'bg-secondary hover:bg-secondary/90 text-white',
        'outline-success':
          'border-green-500 hover:border-green-600 text-green-600 hover:bg-green-500 hover:text-white border',
        'outline-danger': 'border-red-500 text-red-600 hover:bg-red-500 hover:text-white border',
        'outline-warning':
          'border-yellow-500 hover:border-yellow-600 text-yellow-600 hover: border',
        'outline-info':
          'border-blue-500 hover:border-blue-600 text-blue-600 hover:bg-blue-500 hover:text-white border',
        'outline-primary': 'border-primary hover:border-primary/90 hover:bg-primary hover:text-white text-primary hover: border',
        'outline-secondary':
          'border-secondary hover:border-secondary/90 text-secondary hover: border',
        'flat-primary': 'text-primary hover:bg-primary/90 hover:text-white',
        'flat-danger': 'text-red-600 hover:bg-red-50 hover:text-red-600 '
      },
      size: {
        small: 'p-2 text-xs rounded-md',
        medium: 'px-4 py-2 text-sm rounded-md',
        large : 'py-3.6 px-10 text-sm rounded-md'
      }
    },
    compoundVariants: [{ type: 'primary', class: 'bg-none' }]
  }
)

type ButtonProps = VariantProps<typeof button>

withDefaults(
  defineProps<{ type?: ButtonProps['type']; size?: ButtonProps['size']; loading?: boolean, buttonType? : "submit" | 'button' }>(),
  {
    type: 'primary',
    size: 'medium',
    buttonType : 'button'
  }
)
</script>

<style scoped></style>
